<template>
  <el-form
    ref="airportForm"
    :model="model"
    :rules="rules"
    label-width="10em"
    label-position="left"
    class="airport-form"
  >
    <template v-if="searchMode">
      <Date v-model="searchBaseDate" prop="search_base_date" label="検索基準日" :searchCond="searchMode" />
    </template>
    <template v-else-if="editMode">
      <div class="el-form--inline">
        <Date v-model="startDate" prop="start_date" label="適用開始日" :searchCond="searchMode" :disabled="true" />
        <Date v-model="endDate" prop="end_date" label="適用終了日" :searchCond="searchMode" :required="true" limit="to" :limitDate = startDate />
      </div>
    </template>
    <template v-else>
      <DateRange :dateFrom.sync="startDate" :dateTo.sync="endDate" label="適用期間" :required="!searchMode" :searchCond="searchMode" />
    </template>
    <div class="el-form--inline">
      <AirportCode v-model="airportCode" :required="!searchMode" :searchCond="searchMode"
        :disabled="editMode" :autofocus="!editMode" :autocomplete-list="autocompleteAirportCodeSet" />
      <Blank />
    </div>
    <AirportName v-model="airportName" :required="!searchMode" :searchCond="searchMode"
      :autocomplete-list="autocompleteAirportNameSet" />
    <div class="el-form--inline">
      <RemoteIslandType v-model="remoteIslandType" :required="!searchMode" :searchCond="searchMode" :initialize="true" />
      <Blank />
    </div>
  </el-form>
</template>

<script>
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import AirportName from '@/components/molecules/form/autocomplete/AirportName.vue'
import Date from '@/components/molecules/form/date/Date.vue'
import DateRange from '@/components/molecules/form/date/DateRange.vue'
import RemoteIslandType from '@/components/molecules/form/select/RemoteIslandType.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'

export default {
  components: {
    AirportCode,
    AirportName,
    Date,
    DateRange,
    RemoteIslandType,
    Blank
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportNameSet: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {}
  },
  computed: {
    airportCode: {
      get () {
        return this.model.airport_code
      },
      set (airportCode) {
        const form = { ...this.model }
        form.airport_code = airportCode
        this.$emit('input', form)
      }
    },
    searchBaseDate: {
      get () {
        return this.model.search_base_date
      },
      set (searchBaseDate) {
        const form = { ...this.model }
        form.search_base_date = searchBaseDate
        this.$emit('input', form)
      }
    },
    startDate: {
      get () {
        return this.model.start_date
      },
      set (startDate) {
        const form = { ...this.model }
        form.start_date = startDate
        this.$emit('input', form)
      }
    },
    endDate: {
      get () {
        return this.model.end_date
      },
      set (endDate) {
        const form = { ...this.model }
        form.end_date = endDate
        this.$emit('input', form)
      }
    },
    airportName: {
      get () {
        return this.model.airport_name
      },
      set (airportName) {
        const form = { ...this.model }
        form.airport_name = airportName
        this.$emit('input', form)
      }
    },
    remoteIslandType: {
      get () {
        return this.model.remote_island_type
      },
      set (remoteIslandType) {
        const form = { ...this.model }
        form.remote_island_type = remoteIslandType
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.airportForm.resetFields()
      if (!this.editMode) {
        this.model.search_base_date = null
        this.model.start_date = null
        this.model.end_date = null
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.airportForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.airport-form {
  .el-form-item.airport-name{
    .el-input__inner{
      width: 49em;
    }
  }
}
</style>
